<template>
    <div>
        Rate driver
    </div>
</template>

<script setup lang="ts"></script>
